import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import "@fortawesome/fontawesome-free/css/all.min.css";
import qs from "qs";

let str = window.location.hash.split("?")[1];
str = qs.parse(str);

Vue.use(Vuetify, {
    iconfont: "fa",
    rtl: str && str.language === "ar"
});
